import './flight-filters.scss';
import AtcFlightFiltersService from './flight-filters-service';

const MODULE_NAME = 'app.atc.flights.flight-filters';
const module = angular.module(MODULE_NAME, [])
    .service(AtcFlightFiltersService.SERVICE_NAME, AtcFlightFiltersService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/atc/atc-flights-view/filters/flight-filters-module.js